module.exports = __webpack_public_path__ + "img/Mb_MiddleSide_right.150f1631.jpg";